import React, {FC} from 'react';

import {FrameProps} from './frameHelpers';
import {ModernFrame} from './modernFrame';

export const Frame: FC<FrameProps> = (props) => <ModernFrame {...props} />;
